import * as Yup from "yup"
import { cn } from "../lib/utils"

export const registerFlowSteps = [
  {
    id: "email",
    fieldType: "text",
    fieldName: "email",
    label: "Email",
    title: "Sign up to Encircled!",
    subtitle: "Enter your email to get started.",
    fieldProps: { placeholder: "Enter your email" },
    validation: Yup.object().shape({
      email: Yup.string().email().required(),
    }),
  },
  {
    id: "name",
    fields: [
      {
        fieldType: "text",
        fieldName: "first_name",
        label: "First",
        fieldProps: { placeholder: "Enter your first name" },
      },
      {
        fieldType: "text",
        fieldName: "last_name",
        label: "Last",
        fieldProps: { placeholder: "Enter your last name" },
      },
    ],
    title: "Set your name",
    subtitle: "To start, what's your name?",
    validation: Yup.object({
      first_name: Yup.string().required(),
      last_name: Yup.string().required(),
    }),
  },
  {
    id: "password",
    fieldType: "password",
    fieldName: "password",
    label: "Password",
    title: values => `Nice to meet you, ${values.first_name || "there"}!`,
    subtitle: "Now, set a strong password by following the requirements below.",
    fieldProps: { placeholder: "Enter your password" },
    validation: Yup.object({
      password: Yup.string().required(),
    }),
    contentAfterField: true,
    renderCustomContent: values => {
      const password = values.password ?? ""

      const passwordMinMet = password.length >= 8
      const passwordUppercaseMet = password.match(/[A-Z]/)
      const passwordLowercaseMet = password.match(/[a-z]/)
      const passwordNumberMet = password.match(/[0-9]/)
      const passwordSpecialMet = password.match(/[!@#$%^&*(),.?":{}|<>]/)

      const Icon = ({ requirementMet }) => {
        return (
          <i
            className={cn(
              "fa-solid mr-2",
              requirementMet ? "fa-circle-check text-brand" : "fa-circle-x text-red-600",
            )}
          ></i>
        )
      }

      return (
        <div className="px-8 py-4 text-center">
          <ul className="grid grid-cols-2 gap-4 text-left">
            <li>
              <Icon requirementMet={passwordMinMet} />
              <span>Min. 8 characters</span>
            </li>
            <li>
              <Icon requirementMet={passwordLowercaseMet && passwordUppercaseMet} />
              <span>Upper and lowercase letters</span>
            </li>
            <li>
              <Icon requirementMet={passwordNumberMet} />
              <span>A number</span>
            </li>
            <li>
              <Icon requirementMet={passwordSpecialMet} />
              <span>A special character</span>
            </li>
          </ul>
        </div>
      )
    },
  },
]

export const registerFlowInitialValues = { email: "" }
